import {UserRole} from "../../../../types/auth.types";
import {ResourceParams, resources} from "../../../../models/resource/resources";
import {FilesStatus} from "../../../../types/files-status.types";
import {defaultFilesStatus} from "../../../../models/default-file-params";

export const advertisementInitialStatisticsResourceType: ResourceParams = resources['advertisement-initial-statistics'];

export const adminAndReviewerRoles: Array<UserRole> = [
  'ROLE_ADMIN',
  'ROLE_REVIEWER'
]

export const defaultAdvertisementInitialStatisticsFilesStatus: FilesStatus = {
  ...defaultFilesStatus,
  initialStatisticsStatus: 'ERROR'
}
